import type { ReactNode } from "react"

/**
 * Shared responsive grid for agent list pages (voice / email / messaging).
 * 3 columns start at xl, not lg: at 1024px (iPad Pro portrait) the sidebar
 * leaves too little width per card, so a third column overflows its track.
 */
export function AgentsGrid({
  children,
  /** Two columns max — for cards carrying per-channel detail that needs the width. */
  wide = false,
}: {
  children: ReactNode
  wide?: boolean
}) {
  return (
    <div
      className={
        wide
          // Tracks stay between 320 and 460px: never cramped, never stretched by a lone agent.
          ? "grid gap-6 grid-cols-[repeat(auto-fill,minmax(min(100%,320px),460px))]"
          : "grid grid-cols-1 md:grid-cols-2 xl:grid-cols-3 gap-6"
      }
    >
      {children}
    </div>
  )
}
